import React from "react";

export const Logo = ({ size = "md", showText = false, inverted = false, className = "" }) => {
  const sizes = {
    xs: { box: "h-8 w-8", text: "text-sm", sub: "text-[9px]" },
    sm: { box: "h-10 w-10", text: "text-base", sub: "text-[10px]" },
    md: { box: "h-12 w-12", text: "text-lg", sub: "text-[11px]" },
    lg: { box: "h-20 w-20", text: "text-2xl", sub: "text-xs" },
    xl: { box: "h-28 w-28", text: "text-3xl", sub: "text-sm" },
  };
  const s = sizes[size] || sizes.md;

  // The logo image already contains "T&J Clinical Solutions" text; showText only adds a tagline.
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <div
        className={`${s.box} grid place-items-center rounded-full overflow-hidden shrink-0`}
        style={{
          background: inverted ? "#FFFFFF" : "transparent",
          boxShadow: inverted ? "0 0 0 1px rgba(212,175,55,0.4)" : "none",
        }}
      >
        <img
          src="/tj-logo.png"
          alt="T&J Clinical Solutions"
          className="h-full w-full object-contain"
          loading="eager"
          decoding="async"
        />
      </div>
      {showText ? (
        <div className="leading-tight">
          <div
            className={`font-display font-bold tracking-tight ${s.text}`}
            style={{ color: inverted ? "#FFFFFF" : "#0B2545" }}
          >
            T&amp;J Clinical Solutions
          </div>
          <div
            className={`uppercase tracking-[0.22em] font-medium ${s.sub}`}
            style={{ color: inverted ? "#E6C765" : "#475569" }}
          >
            Healthcare Support Services
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default Logo;
